import { createAction, props } from '@ngrx/store';
import { PCO_STATUS, PcoSortingField } from '@app/store/pco/pco.types';

const onPCOListingAccess = createAction('[PCO listing] PCO listing access');

const onPCOListingSearch = createAction(
  '[PCO listing] PCO listing search',
  props<{ search: string }>(),
);
const onPCOListingStatusChange = createAction(
  '[PCO listing] PCO listing status filter change',
  props<{ statuses: PCO_STATUS[] }>(),
);

const onPCOListingNextPageNeeded = createAction('[PCO listing] PCO listing next page needed');

const onPCOSortingChange = createAction(
  '[PCO listing] PCO listing sorting change',
  props<{ sortBy: PcoSortingField; sortDirection: 'asc' | 'desc' }>(),
);

export const pcoListingActions = {
  onPCOListingAccess,
  onPCOListingSearch,
  onPCOListingStatusChange,
  onPCOListingNextPageNeeded,
  onPCOSortingChange,
};
